import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { TaskContext } from "../context/TaskContext";

function AddTask() {
  const { addTask, editTask, tasks } = useContext(TaskContext);
  const { id } = useParams();
  const taskEdit = tasks.find(
  task => task.id === Number(id)
  );
  const [title, setTitle] = useState(taskEdit ? taskEdit.title : "");
  
  const navigate = useNavigate();

  

  function handleSubmit(e) {
    e.preventDefault();

    const newTask = {
      id: taskEdit ? taskEdit.id : Date.now(),
      title,
    };

    if(taskEdit) {
      editTask(newTask);
    } else {
      addTask(newTask);
    }
    

    navigate("/");
  }

  return (
    <div className="container-add-task">
      <div className="icon">
         <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0776 13.0083C10.0647 13.6366 8.86615 14 7.58169 14C3.94672 14 1 11.0899 1 7.5C1 3.91015 3.94672 1 7.58169 1C9.88894 1 11.9189 2.17248 13.094 3.94703" stroke="white" stroke-width="2"/>
        <path d="M12.5361 8.76685V13.2287M10.1194 10.9978H14.9999" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <path d="M4.93213 5.7649L6.3137 8.26315C6.62176 8.8202 7.36498 8.95145 7.84521 8.53361L14.4142 2.81787" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>

      </div> 
      
      <h1>Adicionar Nova tarefa</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="title">Nome da Tarefa</label>
          <input type="text"  placeholder="Ex: Finalizar relatório mensal" value={title} onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <button type="submit">
          {taskEdit ? 'Editar' : 'Adicionar'}
        </button>
      </form>
    </div>
  );
}

export default AddTask;